









import { Component, Vue } from 'vue-property-decorator';
import UserForm from '@/components/user/UserForm.vue';
import { Getter, Action } from 'vuex-class';
import { User } from '@/models/user.interface';

@Component({
  components: {
    UserForm,
  },
})
export default class UserEdit extends Vue {
  @Getter public selectedUser!: User;
  @Action('getUserAction') public getUserAction!: (id: string) => void;
  @Action('resetUserWorkflowAction') public resetUserWorkflowAction!: () => void;

  private mounted(): void {
    if (!this.selectedUser) {
      this.getUserAction(this.$route.params.id);
    }
    this.resetUserWorkflowAction();
  }
}
